import { Box, Fade, Slide, useMediaQuery } from "@mui/material";
import style from "./style.module.scss";
import { forwardRef, useMemo, useState } from "react";
import { Contact } from "../ContactPartner";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { checkEmptyObj, checkIf } from "../../utils";
import { ChatIcon } from "../../assets/icons";
import { useLocation } from "react-router-dom";
import { getTenant } from "../../theme";

export const GetInTouch = forwardRef(function (props, ref) {
  const { pathname } = useLocation();
  const hidden = useMemo(() => {
    return pathname.includes("/partners/");
  }, [pathname]);
  const tenant = getTenant();
  const [display, setDisplay] = useState(false);
  const user = useSelector((state: RootState) => state.user);
  const activeSubscription = user?.activeSubscription;
  const onClose = () => {
    setDisplay(false);
  };
  const mobile = useMediaQuery("only screen and (max-width: 600px)");

  const positionStyle = mobile ? { bottom: "86px", right: "16px" } : { bottom: "32px", right: "32px" };

  return (
    <>
      {checkEmptyObj(user) || hidden || !checkIf(activeSubscription) ? null : (
        <Box onClick={(e) => setDisplay((state) => !state)} className={style.wrapper} sx={{ ...positionStyle }}>
          <ChatIcon />
        </Box>
      )}

      <>
        <Fade in={display}>
          <Box className="payment-section-bg"></Box>
        </Fade>
        <Slide direction="up" in={display} mountOnEnter unmountOnExit>
          <Contact onClose={onClose} />
        </Slide>
      </>
    </>
  );
});
